import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=c4786432&scoped=true"
import script from "./DataCard.vue?vue&type=script&lang=js"
export * from "./DataCard.vue?vue&type=script&lang=js"
import style0 from "./DataCard.vue?vue&type=style&index=0&id=c4786432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4786432",
  null
  
)

export default component.exports